export class TokenResponse {
  access_token: string;
  username: string
  constructor(tokenResponse: object) {
    Object.assign(this, tokenResponse);
  }
}
